import { render, staticRenderFns } from "./Invitegroup.vue?vue&type=template&id=216f8c72&scoped=true&"
import script from "./Invitegroup.vue?vue&type=script&lang=ts&"
export * from "./Invitegroup.vue?vue&type=script&lang=ts&"
import style0 from "./Invitegroup.vue?vue&type=style&index=0&id=216f8c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216f8c72",
  null
  
)

export default component.exports